import BQuantity from "./BQuantity";

export default class BRestQuantity
{
	constructor(source)
	{
		this.source = source;
	}

	getQuantity()
	{
		try {
			return new BQuantity(this.source.amount, this.source.unit.abbr);
		} catch (error) {
			return null;
		}
	}
}
